import React from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router';

/** Sign out and go home: the sidebar's account row and the settings index. */
export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return React.useCallback(() => {
    dispatch({type: 'LOGOUT'});
    navigate('/');
  }, [dispatch, navigate]);
};
